<template>
  <div>
    <div v-if="displayMobileView === false" class="position-relative">
      <EdcFormInfo v-if="edcFormInfo.formId" :edcFormInfo="edcFormInfo" @openApprovalModal="openApprovalModal" @openLockModal="openLockModal" @openReviewModal="openReviewModal" @openSignoffModal="openSignoffModal" @openVerificationModal="openVerificationModal"></EdcFormInfo>
      <div class="participant-detail-section">
        <div class="action-btns">
          <div class="activity-status-container d-flex justify-content-between align-items-center position-relative pr-50" v-if="!!activityForm || (!!edcFormInfo && Object.keys(edcFormInfo).length > 0)">
            <div class="activity-status__language pt-17 pb-20">
              <b-form-select v-model="selectedLanguageCulture" size="sm" class="language-dropdown" @change="onSelectedLanguageCultureChange">
                <option v-for="language in languages" :key="language.language_id" :value="language.language_culture">{{ language.name }}</option>
              </b-form-select>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-default btn-md action-btn btn-padding mt-10"
            id="show-document-ele"
            v-if="areActionsAllowed.document && (canPiAccess || canSubPiAccess || canHomeHealthAccess || canScAccess || canCraAccess || canSiteDataLockAccess || canStudyManagerAccess || canBioStatisticsAccess || canPharmacovigilanceAccess || user.readOnly || canStudyAdminAccess || canCallCenterAccess || canCraUBAccess)"
            @click="switchText('document')"
            :class="{ btnActive: showDocuments }"
          >
            <span
              class="mb-3 pl-17"
              :class="{
                'agreement-off': !showDocuments,
                'agreement-on': showDocuments
              }"
            ></span
            >{{ showDocuments ? "Hide" : "Show" }} Agreements
          </button>

          <button type="button" class="btn btn-default btn-md action-btn btn-padding mt-10" @click="changeState('study-participant-edc-unschedule-packets-reskin')" v-if="areActionsAllowed.edcforms && edcEnabled && (canPiAccess || canSubPiAccess || canHomeHealthAccess || canScAccess || canStudyAdminAccess || canInterviewerAccess || canCallCenterAccess || canRaterAccess) && !user.readOnly">
            <span class="forms mb-3 pl-17"></span>Unscheduled Forms
          </button>

          <button type="button" class="btn btn-default btn-md btn-padding mt-10" v-if="areActionsAllowed.send" @click="showSignatureModal('confirmSendModal')" :disabled="user.userRole === 'Cra' || user.userRole === 'CraUB' || user.userRole === 'SiteDataLock' || user.readOnly || this.getSignatureStatus === this.signatureStatuses.SIGNATURE_ACQUIRED || isButtonCanceled || documentDetails.invalidate">
            <i class="fa fa-paper-plane pr-5" aria-hidden="true"></i>Send to Participant
          </button>

          <button
            type="button"
            class="btn btn-default btn-md active btn-padding mt-10"
            v-if="areActionsAllowed.sign"
            @click="showSignatureModal('signatureModal')"
            :disabled="
              isDocumentConfigured ||
                !hasDocumentField ||
                !documentDetails.isParticipantSigned ||
                documentDetails.isPISigned ||
                !documentDetails.isPISignRequired ||
                documentDetails.docName == 'THREAD Study Application End User License Agreement' ||
                user.userRole === 'Cra' ||
                user.userRole === 'CraUB' ||
                user.userRole === 'SiteDataLock' ||
                user.readOnly ||
                this.getSignatureStatus === this.signatureStatuses.SIGNATURE_ACQUIRED ||
                isButtonCanceled ||
                documentDetails.invalidate ||
                (documentDetails.docName.toLowerCase().trim() == 'datavant tokenization consent' && documentDetails.siteId == null)
            "
          >
            <span class="sign"></span>Sign
          </button>

          <button type="button" class="btn btn-default btn-md btn-padding mt-10" v-if="areActionsAllowed.print" :disabled="this.getSignatureStatus === this.signatureStatuses.SIGNATURE_ACQUIRED" @click="printDocument()"><i class="fa fa-print pr-5" aria-hidden="true"></i>Print</button>

          <button
            type="button"
            class="btn btn-default btn-md btn-padding send-activity-pb mt-10"
            :class="{ btnActive: toggleSendActivity }"
            @click="getParticipantDetails()"
            v-if="areActionsAllowed.onDemandActivity && (canPiAccess || canSubPiAccess || canHomeHealthAccess || canScAccess || user.readOnly || canInterviewerAccess || canCallCenterAccess) && canSendActivity && activityList && activityList.length && !(participantDetails.status === 'ACTIVEWITHOUTAPP')"
            :disabled="this.getSignatureStatus === this.signatureStatuses.SIGNATURE_ACQUIRED"
          >
            <span
              class="mb-1 pl-13"
              :class="{
                'send-activity-on': toggleSendActivity,
                'send-activity-off': !toggleSendActivity
              }"
            ></span
            >Send Activity
          </button>

          <div class="vertical-seperator" v-if="(areActionsAllowed.send || areActionsAllowed.document || areActionsAllowed.sign || areActionsAllowed.print || areActionsAllowed.edcforms) && !canSysAdminAccess && canInitiateTelehealthCall() && !user.readOnly"></div>

          <button
            type="button"
            class="btn btn-default btn-md action-btn btn-padding mt-10"
            v-if="areActionsAllowed.telehealth && canInitiateTelehealthCall() && !canSiteDataLockAccess && !user.readOnly && !(participantDetails.status === 'ACTIVEWITHOUTAPP') && participantDetails.status != 'SCREENING'"
            @click="InitateVideoCall"
            :disabled="disableCallBtn() || this.getSignatureStatus === this.signatureStatuses.SIGNATURE_ACQUIRED || isButtonCanceled || documentDetails.invalidate"
          >
            <span class="telehealth mb-3 pl-17"></span>Start Telehealth
          </button>

          <button
            type="button"
            class="btn btn-outline-danger btn-md action-btn btn-padding invalidate-btn mt-10"
            :class="invalidateBtn"
            v-if="areActionsAllowed.resendSign && !isEConsent"
            :disabled="!documentDetails.isParticipantSigned || user.userRole === 'Cra' || user.userRole === 'CraUB' || user.userRole === 'SiteDataLock' || user.readOnly || isButtonCanceled || documentDetails.invalidate"
            @click="openInvalidateModal"
          >
            <span class="invalid mb-2 pl-17"></span>Invalidate Document
          </button>

          <button v-if="areActionsAllowed.sendMessage && canResearchSiteTeamAccess && !user.readOnly" type="button" class="btn btn-default btn-md action-btn btn-padding mt-10" :class="{ btnActive: showSendMessage }" @click="toggleMessageSection()">
            <span
              class="mb-1 pl-17"
              :class="{
                'send-message-off': !showSendMessage,
                'send-message-on': showSendMessage
              }"
            ></span>

            {{ showSendMessage ? "Close" : "Send" }} Messages
          </button>
          <button type="button" class="btn btn-default btn-md btn-padding send-activity-pb mt-10" v-if="isPreScreenedFlag" :class="{ btnActive: togglePreStudyStartActivity }" @click="togglePreStudyStartSection(true, !togglePreStudyStartActivity)">
            <span
              class="mb-1 pl-13"
              :class="{
                'send-activity-on': togglePreStudyStartActivity,
                'send-activity-off': !togglePreStudyStartActivity
              }"
            ></span
            >Pre-Study Start
          </button>
          <!-- adding milestone action button -->
          <button type="button" v-if="toggleMilestoneOnViewAll && actualMilestones && actualMilestones.length > 0" @click="toggleMilestoneDataAction()" class="btn btn-default btn-md action-btn btn-padding mt-10" :class="{ btnActive: showMilestoneMessage }"><i class="fa fa-check-circle-o pr-5 fs-16" aria-hidden="true"></i>Milestone Actions</button>
        </div>
      </div>
      <transition name="fade">
        <DocumentsList v-if="showDocuments" :toggleFeatures="toggleFeatures"></DocumentsList>
        <div v-if="showSendMessage && participantDetails && composeMessageId">
          <ParticipantSendMessage
            v-on:toggleMessageSec="toggleMessageSecEvHan"
            :participantInfo="{
              participantId: participantDetails.id,
              emailId: participantDetails.email,
              phoneNumber: participantDetails.phoneNumber,
              optInSMS: participantDetails.optInSMS
            }"
            :participantComMsgId="composeMessageId"
          ></ParticipantSendMessage>
        </div>
      </transition>
      <!--Edit participant id modal-->
      <div v-if="edcFormInfo.formId">
        <user-verification-modal ref="userVerificationModal" />
        <user-confirmation-modal ref="userConfirmationModal" />
      </div>
      <!-- signatureModal -->
      <b-modal id="signatureModal" class="signature-modal" ref="signatureModal" :busy="true" :hide-footer="true" :hide-header="true" body-class="modal-body-custom">
        <template>
          <h3 class="h3 text-center mb-32">Site Team</h3>
          <div v-if="!signed">
            <div role="group">
              <label for="inputLive" class="font-weight-bold">Enter your name:</label>
              <b-form-input id="inputLive" v-model.trim="name" type="text" placeholder="First and last name"></b-form-input>
              <span class="color_red fs-12" v-if="name && name.length > charLimit">Enter max of {{ charLimit }} characters only</span>
            </div>
            <div role="group" class="pt-20" v-if="extraData.showInitial">
              <label for="inputLive" class="m-0 font-weight-bold">Draw your initials with your mouse or keyboard:</label>
              <VueSignaturePad
                id="siteInitial"
                width="359px"
                height="95px"
                class="signature-canvas"
                ref="siteInitial"
                :options="{
                  onBegin: () => {
                    $refs.siteInitial.resizeCanvas();
                  },
                  onEnd: storeSiteInitial
                }"
              />
              <a class="clear" @click="undoLastInitialSignature">Clear</a>
            </div>
            <div role="group" class="pt-20" v-if="extraData.showSignature">
              <label for="inputLive" class="m-0 font-weight-bold">Draw your signature with your mouse or keyboard:</label>
              <VueSignaturePad
                id="siteSignature"
                width="359px"
                height="95px"
                class="signature-canvas"
                ref="siteSignature"
                :options="{
                  onBegin: () => {
                    $refs.siteSignature.resizeCanvas();
                  },
                  onEnd: setSiteSignatureData
                }"
              />
              <a class="clear" @click="undoLastSignature">Clear</a>
            </div>
          </div>
          <div class="text-center pt-10 action-buttons d-flex flex-column">
            <b-button v-if="documentDetails && documentDetails.consentId" class="mb-16" @click="confirmSign()" :disabled="!name || !getSignatureData || (name && name.length > charLimit)">Confirm Signature</b-button>
            <b-button v-else @click="collectBinaryData('signatureModal')" class="mb-16" :disabled="!name || !((getBase64SignatureData || !extraData.showSignature) && (getBase64InitialData || !extraData.showInitial)) || (name && name.length > charLimit)">Continue</b-button>
            <b-button v-if="!signed" @click="closeModal('signatureModal', true, true, 'signed')">Cancel</b-button>
          </div>
        </template>
      </b-modal>

      <!-- Login Modal -->
      <b-modal class="signature-modal" ref="loginModal" :busy="true" :hide-footer="true" :hide-header="true" body-class="modal-body-custom">
        <div v-if="completed">
          <div class="pb-20 text-center">
            Herewith I confirm the completeness and correctness of all data entered into the THREAD Platform by applying an electronic signature, using my account name and password. This electronic signature is the legally binding equivalent of my handwritten signature. I understand that this electronic signature is assigned only to my account name and password; no other person is authorized to
            use these.
          </div>
          <div class="pb-20 text-center">
            Please enter username and password to sign this document. You may not rescind your signature once you have signed the document
          </div>
          <div role="group" class="pl-40 pr-40">
            <b-form-input v-if="awsCognitoAuthentication && awsCognitoAuthentication === true" type="text" placeholder="Username" v-model="userCredentials.username"></b-form-input>
            <b-form-input v-else type="text" placeholder="Email" v-model="userCredentials.username"></b-form-input>
          </div>
          <div role="group" class="pl-40 pr-40 pt-20">
            <b-form-input type="password" placeholder="Password" v-model="userCredentials.password"></b-form-input>
          </div>
          <div class="text-center pt-10 d-flex flex-column">
            <b-button variant="primary" class="custom-btn" v-on:click.prevent="loginUser" :disabled="!userCredentials.username || !userCredentials.password">Confirm and sign</b-button>
          </div>
        </div>
        <div class="text-center pt-10 action-buttons d-flex flex-column">
          <b-button v-if="!signed" @click="closeModal('loginModal', true, true, 'signed')">Cancel</b-button>
          <b-button v-if="completed" @click="closeModal('loginModal', true, false, 'completed')">Do not sign</b-button>
        </div>
      </b-modal>

      <!-- Confirm First Witness modal -->
      <b-modal id="witnessConfirmation" ref="witnessConfirmationModal" class="signature-modal" :busy="true" :hide-footer="true" :hide-header="true" body-class="witness-modal-body">
        <h5 class="h3 text-center mb-32">Will a witness be signing?</h5>
        <div class="text-center mt-24 action-buttons d-flex flex-column">
          <b-button variant="primary mb-16" @click="showSignatureModal('witnessOneModal')">Yes</b-button>
          <b-button variant="primary" @click="clearAndShowAuth(1)">No</b-button>
        </div>
      </b-modal>

      <!-- Confirm Additional Witness modal -->
      <b-modal id="witnessConfirmation" ref="witnessTwoConfirmationModal" class="signature-modal" :busy="true" :hide-footer="true" :hide-header="true" body-class="witness-modal-body">
        <h5 class="h3 text-center mb-32">
          Will an additional witness be signing?
        </h5>
        <div class="text-center mt-24 action-buttons d-flex flex-column">
          <b-button variant="primary mb-16" @click="showSignatureModal('witnessTwoModal')">Yes</b-button>
          <b-button variant="primary" @click="clearAndShowAuth(2)">No</b-button>
        </div>
      </b-modal>

      <!-- Witness #1 Signature modal -->
      <b-modal class="signature-modal" ref="witnessOneModal" :busy="true" :hide-footer="true" :hide-header="true" body-class="modal-body-custom">
        <h3 class="h3 text-center mb-32">Witness #1</h3>
        <div>
          <div role="group">
            <label class="font-weight-bold mb-8" for="inputLive">Enter your name:</label>
            <b-form-input id="inputLive" v-model.trim="witnessName" type="text" placeholder="First and last name" @input.native="setName($event, 1)"></b-form-input>
            <span class="color_red fs-12" v-if="witnessName && witnessName.length > charLimit">Enter max of {{ charLimit }} characters only</span>
          </div>
          <!-- check if witness intitals required -->
          <div v-if="witnessConfiguration['1'] && witnessConfiguration['1'].includes('initials')" role="group" class="pt-20">
            <label for="inputLive" class="m-0 font-weight-bold mb-8">Draw your initials with your mouse or keyboard:</label>

            <VueSignaturePad
              id="initial"
              width="359px"
              class="signature-canvas"
              height="95px"
              ref="witnessInitial1"
              :options="{
                onBegin: () => {
                  $refs.witnessInitial1.resizeCanvas();
                }
              }"
            />
            <a class="clear" @click="$refs.witnessInitial1.undoSignature()">Clear</a>
          </div>
          <div v-if="witnessConfiguration['1'] && witnessConfiguration['1'].includes('signature')" role="group" class="pt-20">
            <label for="inputLive" class="m-0 font-weight-bold mb-8">Draw your signature with your mouse or keyboard:</label>
            <VueSignaturePad
              id="signature"
              width="359px"
              class="signature-canvas"
              height="95px"
              ref="witnessSignature1"
              :options="{
                onBegin: () => {
                  $refs.witnessSignature1.resizeCanvas();
                }
              }"
            />
            <a class="clear" @click="$refs.witnessSignature1.undoSignature()">Clear</a>
          </div>
          <div class="text-center mt-24 action-buttons d-flex flex-column">
            <b-button variant="primary mb-16" @click="verifyWitnessTwo">Continue</b-button>
            <b-button variant="primary" @click="clearAndShowAuth(1)">Cancel</b-button>
          </div>
        </div>
      </b-modal>

      <b-modal class="signature-modal" ref="witnessTwoModal" :busy="true" :hide-footer="true" :hide-header="true" body-class="modal-body-custom">
        <h3 class="h3 text-center mb-32">Witness #2</h3>
        <div>
          <div role="group">
            <label class="font-weight-bold mb-8" for="inputLive">Enter your name:</label>
            <b-form-input id="inputLive" v-model.trim="witnessTwoName" type="text" placeholder="First and last name" @input.native="setName($event, 2)"></b-form-input>
            <span class="color_red fs-12" v-if="witnessTwoName && witnessTwoName.length > charLimit">Enter max of {{ charLimit }} characters only</span>
          </div>
          <!-- check if witness intitals required -->
          <div v-if="witnessConfiguration['2'] && witnessConfiguration['2'].includes('initials')" role="group" class="pt-20">
            <label for="inputLive" class="m-0 font-weight-bold mb-8">Draw your initials with your mouse or keyboard:</label>

            <VueSignaturePad
              id="initialWitnessTwo"
              width="359px"
              class="signature-canvas"
              height="95px"
              ref="witnessInitial2"
              :options="{
                onBegin: () => {
                  $refs.witnessInitial2.resizeCanvas();
                }
              }"
            />
            <a class="clear" @click="$refs.witnessInitial2.undoSignature()">Clear</a>
          </div>
          <div v-if="witnessConfiguration['2'] && witnessConfiguration['2'].includes('signature')" role="group" class="pt-20">
            <label for="inputLive" class="m-0 font-weight-bold mb-8">Draw your signature with your mouse or keyboard:</label>
            <VueSignaturePad
              id="signatureWitnessTwo"
              width="359px"
              class="signature-canvas"
              height="95px"
              ref="witnessSignature2"
              :options="{
                onBegin: () => {
                  $refs.witnessSignature2.resizeCanvas();
                }
              }"
            />
            <a class="clear" @click="$refs.witnessSignature2.undoSignature()">Clear</a>
          </div>
          <div class="text-center mt-24 action-buttons d-flex flex-column">
            <b-button variant="primary mb-16" @click="setWitnessAndContinue">Continue</b-button>
            <b-button variant="primary" @click="clearAndShowAuth(2)">Cancel</b-button>
          </div>
        </div>
      </b-modal>

      <!-- confirmSendModal -->
      <b-modal id="confirmSendModal" ref="confirmSendModal" :busy="true" :hide-footer="true" :hide-header="true" body-class="modal-body-custom">
        <div class="modal-heading">
          Are you sure you want to send
          <span class="documentname-Wrap" v-if="documentDetails && documentDetails.docName">{{ documentDetails.docName }}</span>
          to participant
          <span class="documentname-Wrap" v-if="documentDetails && documentDetails.toEmail">{{ documentDetails.toEmail }}</span>
        </div>
        <div class="text-center pt-20">
          <b-button variant="primary" class="font-1rem custom-btn" @click="sendMail('confirmSendModal')">Yes, send</b-button>
        </div>
        <div class="text-center pt-10">
          <b-button variant="secondary" class="font-1rem custom-btn" @click="closeModal('confirmSendModal', true, true)">No, do not send</b-button>
        </div>
      </b-modal>
    </div>
    <div v-if="displayMobileView === true">
      <div class="participant-detail-section" v-if="areActionsAllowed.edcforms && edcEnabled">
        <div class="action-btns pt-17 pb-20 text-center">
          <button type="button" class="btn btn-default btn-md action-btn btn-padding mt-10" @click="changeState('study-participant-edc-unschedule-packets-reskin')" v-if="areActionsAllowed.edcforms && edcEnabled && (canPiAccess || canSubPiAccess || canHomeHealthAccess || canScAccess || canStudyAdminAccess || canInterviewerAccess) && !user.readOnly">
            <span class="forms mb-3 pl-17"></span>Unscheduled Forms
          </button>
        </div>
      </div>
    </div>
    <invalidateDocumentModal ref="InvalidateModal" @invalidDocument="invalidateDocument" />
    <resendDocumentModal ref="resendModal" @resendDocument="resendDocument" />
    <EIdentAuthentication ref="eSignAuthenticationModal" :esignAuthData="esignAuthData"></EIdentAuthentication>
  </div>
</template>

<script>
import jwtDecode from "jwt-decode";
import { AclRule } from "vue-acl";
import { mapGetters, mapActions } from "vuex";
import { PI, CC, SUB_PI, STUDY_COORDINATOR, STUDY_ADMIN, CRA, DM, HOME_HEALTH, QUALITY, BSTAT, PHV, SYSTEM_ADMIN, STUDY_MANAGER, participantStatusesText, SITEDATALOCK, INTERVIEWER, RATER, CraUB } from "@/constants/authRoles";
import DocumentsList from "@/components/participants/documents/documents-list-new";
import { approvalStatusText, verificationStatusText, verificationStatus, approvalStatus, reviewStatus, lockStatus, signoffStatus } from "@/constants/form";
import UserConfirmationModal from "@/components/modals/user-confirmation-modal";
import UserVerificationModal from "@/components/modals/user-verification-modal";
import EdcFormInfo from "@/components/form/edc-form-info-new";
import signatureStatuses from "@/constants/signatureStatuses";
import ParticipantSendMessage from "@/components/participants/send-messages";
import localStorageService from "@/services/localStorage";
import * as constant from "@/constants/config";
import _ from "lodash";
import invalidateDocumentModal from "@/components/modals/invalidate-document-modal";
import resendDocumentModal from "@/components/modals/resend-document-modal";
import EIdentAuthentication from "@/components/participants/eIdent-authentication";
export default {
  name: "participant-info",
  components: {
    DocumentsList,
    UserConfirmationModal,
    UserVerificationModal,
    EdcFormInfo,
    ParticipantSendMessage,
    invalidateDocumentModal,
    resendDocumentModal,
    EIdentAuthentication
  },
  props: {
    selectedLanguageCulture: String,
    toggleMilestoneOnViewAll: Boolean,
    milestoneActionStatus: Boolean,
    edcFormInfo: {
      type: Object,
      default: function() {
        return {};
      }
    },
    documentDetails: {
      type: Object,
      default: () => {
        return {};
      }
    },
    participantDetails: {
      type: Object,
      default: function() {
        return {};
      }
    },
    hasToHide: {
      type: Boolean,
      deafult: false
    },
    showWitnessConfirmationModal: {
      type: Boolean,
      deafult: false
    },
    areActionsAllowed: {
      type: Object,
      default: function() {
        return {
          document: true,
          telehealth: true,
          edcforms: true,
          approval: false,
          verifyBtn: false,
          send: false,
          sign: false,
          resendSign: false,
          print: false,
          sendMessage: false,
          onDemandActivity: false
        };
      }
    },
    enableSection: {
      type: Boolean,
      default: true
    },
    extraData: {
      type: Object,
      default: function() {
        return {
          showSignature: false,
          showInitial: false
        };
      }
    },
    toggleWhichSection: {
      type: Object,
      default: null,
      required: false
    },
    triggerDay: {
      type: Object,
      default: () => {}
    },
    participantData: {
      type: Object,
      default: null,
      required: false
    },
    studyResponse: {
      type: Object,
      default: null,
      required: false
    },
    activityForm: {
      type: Object
    },
    languages: {
      type: Array
    },
    isParticipantChange: {
      type: Boolean,
      default: false
    },
    actualMilestones: {
      type: Array
    }
  },
  created() {
    if (constant.SCREENWIDTH > 767) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  data() {
    return {
      activeModal: "",
      studyId: this.$route.params.studyId,
      witnessName: "",
      WitnessSigned: "",
      participantId: this.$route.params.participantId,
      visitDetails: {
        visitId: ""
      },
      teleHealthConfigured: false,
      studyData: {},
      toggleFeatures: [],
      telehealthEnabled: false,
      userDefinedParticipantId: "",
      isTelehealthV2Enabled: false,
      isCallBtnDisabled: false,
      edcEnabled: false,
      showDocuments: false,
      approvalStatusText,
      verificationStatusText,
      signed: false,
      name: null,
      toEmail: null,
      userCredentials: {
        username: "",
        password: ""
      },
      charLimit: 60,
      activeClass: false,
      signingIsInProcess: false,
      signatureStatuses,
      participantStatusesText,
      showSendMessage: false,
      composeMessageId: null,
      completed: false,
      toggleSendActivity: false,
      activityList: [],
      sites: [],
      isPreScreenedFlag: false,
      togglePreStudyStartActivity: false,
      showMilestoneMessage: false,
      witnessData: [],
      witnessTwoName: "",
      witnessConfiguration: {},
      witnessRoleOrders: [],
      witnessSignatures: {},
      isButtonCanceled: false,
      legacyVal: true,
      participantInfo: {},
      esignAuthData: null
    };
  },
  watch: {
    milestoneActionStatus(val) {
      this.showMilestoneMessage = val;
    },
    documentDetails: {
      immediate: true,
      handler() {
        if (typeof this.documentDetails !== "undefined" && typeof this.documentDetails.witnessConfigureList) {
          this.getWitnessDetails();
        }
      }
    },
    getVideoCallStatus(isCallInProgress) {
      this.isCallBtnDisabled = isCallInProgress;
    },
    participantDetails: {
      handler() {
        if (this.showDocuments) {
          this.switchText("document");
        }

        //Since the participant  got changed we need to get back to the initial state, so hide the msg section
        //reinitialize the compose id and remove it from local storage.
        if (this.composeMessageId) {
          localStorageService.removeItem(this.composeMessageId);
          this.composeMessageId = null;
          this.showSendMessage = false;
          //Emit event to show the site/participant task
          this.$emit("toggleSitePartTaskSec", !this.showSendMessage);
          this.$emit("toggleMilestoneAction", false);
        } else if (this.toggleSendActivity) {
          this.toggleSendActivitySection(false, false);
        } else if (this.togglePreStudyStartActivity) {
          this.togglePreStudyStartSection(false, false);
        }
      },
      deep: true
    },
    showDocuments(isShown) {
      if (isShown) {
        //Emit event to show/hide the site/participant task based on the send messages sec is open or not
        this.$emit("toggleSitePartTaskSec", true);
      }
    },
    toggleWhichSection: {
      deep: true,
      immediate: true,
      handler(data) {
        if (data) {
          this.toggleSendActivity = data["toggleSendActivity"];
        }
      }
    },
    isParticipantChange: {
      handler(val) {
        if (val) {
          this.isPreScreenedFlag = false;
          this.getPreScreenedActivityCheck();
        } else {
          return;
        }
      }
    }
  },
  computed: {
    ...mapGetters(["token", "user", "getVideoCallStatus", "getSignatureData", "getSignatureStatus", "getBase64SignatureData", "getBase64InitialData", "awsCognitoAuthentication"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    invalidateBtn() {
      return !this.documentDetails.isParticipantSigned || this.user.userRole === "Cra" || this.user.userRole === "CraUB" || this.user.userRole === "SiteDataLock" || this.user.readOnly || this.isButtonCanceled || this.documentDetails.invalidate ? "invalidate-btn-disabled" : "";
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPiAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canScAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canSubPIAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canRaterAccess() {
      this.$acl.change(`${RATER}`);
      return this.$acl.check("userAccess");
    },
    canInterviewerAccess() {
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    verified() {
      return this.edcFormInfo.verificationStatus === verificationStatus.VERIFIED;
    },
    approved() {
      return this.edcFormInfo.approvalStatus === approvalStatus.APPROVED;
    },
    reviewed() {
      return this.edcFormInfo.reviewStatus === reviewStatus.REVIEWED;
    },
    locked() {
      return this.edcFormInfo.lockStatus === lockStatus.LOCKED;
    },
    signedOff() {
      return this.edcFormInfo.signoffStatus === signoffStatus.SIGNEDOFF;
    },
    canResearchSiteTeamAccess() {
      return this.canPiAccess || this.canSubPIAccess || this.canStudyCoordinatorAccess || this.canHomeHealthAccess || this.canCallCenterAccess;
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    isDocumentConfigured() {
      return !(this.documentDetails.consentId || this.documentDetails.configured || this.isESignRequired);
    },
    isDocConfigured() {
      return !this.documentDetails.consentId && this.documentDetails.configured;
    },
    hasDocumentField() {
      return this.isESignRequired || this.documentDetails.consentId || (this.isDocConfigured && this.documentDetails.siteTeamConfigureList && this.documentDetails.siteTeamConfigureList.length);
    },
    canSendActivity() {
      if (this.user.userRole === "Interviewer") {
        return true;
      }
      let statusArray = ["INVITED", "NOTINVITED", "REGISTERED", "DISQUALIFIED", "WITHDRAWSTUDY"];
      if (!this.legacyVal) {
        statusArray = ["INVITED", "NOTINVITED", "REGISTERED", "DISCONTINUED"];
      }
      if (statusArray.includes(this.participantDetails.status)) {
        return false;
      }
      if (this.studyResponse.isManualStudyStart) {
        return true;
      }
      return true;
    },
    isEConsent() {
      return this.documentDetails && !this.documentDetails.configured && this.documentDetails.preSignedUrl;
    },
    isESignRequired() {
      //check site country and study flag
      const isESignEnabled = _.find(this.toggleFeatures, {
        featureKey: "ElectronicSignature",
        enabled: true
      });

      if (isESignEnabled !== undefined && this.participantDetails.countryName.toLowerCase().indexOf("denmark") !== -1) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    undoLastInitialSignature() {
      this.$refs.siteInitial.undoSignature();
      if (this.$refs.siteInitial.isEmpty()) {
        if (this.documentDetails && !this.documentDetails.consentId) {
          this.setBase64InitialAction(null);
        }
      }
    },
    toggleMilestoneDataAction() {
      //Hide Agreement section if it is visible
      if (this.showDocuments) {
        this.showDocuments = false;
      } else if (this.toggleSendActivity) {
        this.toggleSendActivitySection(false, false);
      } else if (this.togglePreStudyStartActivity) {
        this.togglePreStudyStartSection(false, false);
      } else if (this.showSendMessage) {
        this.showSendMessage = false;
      }
      //Emit event to show/hide the site/participant task based on the send messages sec is open or not
      this.$emit("toggleMilestoneAction", (this.showMilestoneMessage = !this.showMilestoneMessage));
      this.$emit("toggleSitePartTaskSec", !this.showMilestoneMessage);
    },
    undoLastSignature() {
      this.$refs.siteSignature.undoSignature();
      if (this.$refs.siteSignature.isEmpty()) {
        this.setSignatureAction(null);
        if (this.documentDetails && !this.documentDetails.consentId) {
          this.setBase64SignatureAction(null);
        }
      }
    },
    showAdditionalWitnessSigningModal() {
      return;
    },
    getWitnessDetails() {
      this.witnessData = this.documentDetails.witnessConfigureList || [];

      if (this.witnessData.length > 0) {
        this.witnessRoleOrders = _.uniq(
          this.witnessData.map(role => {
            return role.roleOrder;
          })
        );

        this.witnessRoleOrders.forEach(roleId => {
          this.witnessSignatures[roleId] = {
            name: "",
            roleOrder: roleId,
            isSigned: false,
            isInitialAdded: false,
            signature: null,
            initial: null
          };

          this.witnessConfiguration[roleId] = _.uniq(
            this.witnessData
              .filter(witness => {
                return witness.roleOrder === roleId;
              })
              .map(field => {
                return field.fieldType;
              })
          );
        });
      }
    },
    storeSiteInitial() {
      const { data } = this.$refs.siteInitial.saveSignature("image/png");
      if (data) {
        this.setBase64InitialAction(data.split("base64,")[1]);
      }
    },
    onSelectedLanguageCultureChange(value) {
      this.$emit("onLanguageChange", value);
    },
    ...mapActions(["userLogin", "setSignatureAction", "setSignatureStatusAction", "setBase64InitialAction", "setBase64SignatureAction"]),
    openEditModal() {
      this.userDefinedParticipantId = this.participantDetails.userDefinedParticipantId;
      window.$("#edit-participant-modal").modal("show");
    },
    cancelEdit() {
      window.$("#edit-participant-modal").modal("hide");
    },
    updateParticipantID() {
      if (this.userDefinedParticipantId == null || this.userDefinedParticipantId == "") {
        return;
      }
      const dataObj = {
        studyId: this.studyId,
        participantId: this.participantId,
        data: {
          userDefinedParticipantId: this.userDefinedParticipantId.trim()
        }
      };
      this.$api.updateParticipantIdFact(dataObj).then(
        response => {
          this.participantDetails.userDefinedParticipantId = response.body.userDefinedParticipantId;
          this.$forceUpdate();
          this.$toastr.success("Participant ID updated successfully.");
          window.$("#edit-participant-modal").modal("hide");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating the participant id.");
        }
      );
    },
    changeState(state) {
      const params = {
        responseType: "UNSCHEDULED"
      };
      this.$router.push({ name: state, params: params });
    },
    printDocument() {
      const mediaId = this.documentDetails && this.documentDetails.preSignedUrl && this.documentDetails.preSignedUrl.split("?token=")[1];
      if (!mediaId) {
        this.$toastr.error("Error while getting presigned URL.");
        return;
      }
      this.$api.printAgreementDocument({ mediaId }).then(
        () => {
          window.open(this.documentDetails.preSignedUrl, "_blank");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting presigned URL.");
        }
      );
    },
    showSignatureModal(ref) {
      if (this.activeModal !== "") {
        this.$refs[this.activeModal].hide();
      }

      this.activeModal = ref;
      if (ref === "signatureModal") {
        if (this.isESignRequired) {
          //Lets prepare the details we need to send the signature api
          this.esignAuthData = {
            studyId: this.studyId,
            docId: this.documentDetails.docId,
            participantId: this.participantId
          };
          this.$refs["eSignAuthenticationModal"].show();
          return;
        } else {
          this.setSignatureStatusAction(this.signatureStatuses.SIGNATURE_INIT);
        }
      }
      this.$refs[ref].show();
    },
    switchText(button) {
      if (button == "document") {
        if (this.showSendMessage) {
          this.showSendMessage = false;
        } else if (this.toggleSendActivity) {
          this.toggleSendActivitySection(false, false);
        } else if (this.togglePreStudyStartActivity) {
          this.togglePreStudyStartSection(false, false);
        } else if (this.showMilestoneMessage) {
          this.showMilestoneMessage = false;
          this.$emit("toggleMilestoneAction", false);
        }
        this.showDocuments = !this.showDocuments;
      }
    },
    getAppointmentDetails() {
      this.$api.getAppointmentDetailsFact(this.participantId).then(
        response => {
          this.visitDetails = response.body;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting encounter status.");
        }
      );
    },
    getStudyDetails() {
      this.studyData = JSON.parse(window.localStorage.getItem("studyDetailsData"));
      if (!this.canSysAdminAccess) {
        this.getToggledFeatures();
      }
      if (this.teleHealthConfigured && this.canPiAccess) {
        this.getAppointmentDetails();
      }
    },
    getToggledFeatures() {
      this.toggleFeatures = this.$store.getters.getStudyToggledFeatures ? this.$store.getters.getStudyToggledFeatures : JSON.parse(window.localStorage.getItem("toggledFeatures"));
      this.toggleFeatures.forEach(feature => {
        if (feature.featureKey === "TELEHEALTH") {
          this.isTelehealthV2Enabled = feature.enabled;
        } else if (feature.featureKey === "EDC") {
          this.edcEnabled = feature.enabled;
        }
      });
    },
    canInitiateTelehealthCall() {
      //Call cannot be initiated for these statuses
      let statusArray = ["INVITED", "NOTINVITED", "REGISTERED", "DISQUALIFIED", "WITHDRAWSTUDY"];
      if (!this.legacyVal) {
        statusArray = ["INVITED", "NOTINVITED", "REGISTERED", "DISCONTINUED"];
      }
      if (statusArray.includes(this.participantDetails.status)) {
        return false;
      }
      if (this.canInterviewerAccess) {
        return true;
      }

      if (
        this.studyData.telehealthIntegration &&
        this.isTelehealthV2Enabled &&
        (this.canPiAccess || this.canSubPiAccess || this.canScAccess || this.canHomeHealthAccess || this.canCallCenterAccess) &&
        this.user.countries &&
        _.chain(this.user.countries)
          .filter({
            isTelehealthEnabled: true,
            country_id: this.participantDetails.countryId
          })
          .size()
          .value() > 0
      ) {
        return true;
      }

      return false;
    },
    getActivityList() {
      if (!this.participantData) {
        return;
      }
      if (this.user.userRole == "Interviewer") {
        this.participantData.telehealth = true;
      }
      const param = {
        studyId: this.$route.params.studyId,
        participantId: this.$route.params.participantId,
        status: this.participantData && this.participantData.participantDetails && this.participantData.participantDetails.participant && this.participantData.participantDetails.participant.status,
        telehealth: this.participantData.telehealth,
        participantCurrentDay: this.participantData.participantDetails.participantCurrentDay,
        sortOrder: "ASC",
        sortBy: "name",
        pageIndex: 1,
        pageSize: 15
      };
      this.$api.getJITActivityListDataFact(param).then(response => {
        this.activityList = response.body && response.body.activities;
      });
    },
    InitateVideoCall() {
      this.isCallBtnDisabled = true;
      //Emit an event to show/start the video call component
      this.$root.$emit("videoCallStarted", {
        participantId: this.participantDetails.id,
        countryId: this.participantDetails.countryId,
        studyId: this.studyId,
        deviceRegistrationStatus: this.participantDetails.deviceRegistrationStatus
      });
    },
    disableCallBtn() {
      return !!(this.getVideoCallStatus || this.isCallBtnDisabled);
    },
    openReviewModal() {
      let title, desc, submitBtnText, cancelBtnText, yesBtnText, noBtnText;
      if (!this.reviewed) {
        title = "Review Form";
        desc = `I hereby confirm the completeness and correctness of all data entered within this document by applying an electronic signature, using my account username and password.
      This electronic signature is the legally binding equivalent of my handwritten signature. I understand that this electronic signature is assigned 
      only to my account username and password; no other person is authorized to use my account information.<br /><br />
      Please enter your username and password to sign this document.`;
        submitBtnText = "Yes, review";
        cancelBtnText = "No, do not review";

        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
          this.reviewConfirmed({ review: !this.reviewed });
        });
      } else {
        title = "Are you sure you want to rescind the review for this activity?";
        yesBtnText = 'Yes, change to "Unreviewed" status';
        noBtnText = 'No, do not change to "Unreviewed" status';
        this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
          this.reviewConfirmed({ review: !this.reviewed });
        });
      }
    },
    openLockModal() {
      let title, yesBtnText, noBtnText;
      if (!this.locked) {
        title = "Do you wish to lock this activity?";
        yesBtnText = 'Yes, change to "locked" status';
        noBtnText = 'No, do not change to "locked" status';
      } else {
        title = "Are you sure you want to unlock this activity?";
        yesBtnText = 'Yes, change to "unlocked" status';
        noBtnText = 'No, do not change to "unlocked" status';
      }
      this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
        this.lockConfirmed({ locked: !this.locked });
      });
    },
    openSignoffModal() {
      let title, desc, submitBtnText, cancelBtnText;
      if (!this.signedOff) {
        title = "Signed Off Form";
        desc = `Herewith I confirm the completeness and correctness of all data entered into the THREAD Platform by applying an electronic signature, using my account name and password. This electronic signature is the legally binding equivalent of my handwritten signature. I understand that this electronic signature is assigned only to my account name and password; no other person is authorized to use these.<br /><br />Please enter username and password to sign this document.`;
        submitBtnText = "Yes, Signed Off";
        cancelBtnText = "No, do not Signed Off";
        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
          this.signoffConfirmed({ signedoff: !this.signedOff });
        });
      } else {
        title = "Unsigned Off Form";
        desc = `Herewith I confirm the completeness and correctness of all data entered into the THREAD Platform by applying an electronic signature, using my account name and password. This electronic signature is the legally binding equivalent of my handwritten signature. I understand that this electronic signature is assigned only to my account name and password; no other person is authorized to use these.<br /><br />Please enter username and password to sign this document.`;
        submitBtnText = "Yes, Unsigned Off";
        cancelBtnText = "No, do not Unsigned Off";
        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
          this.signoffConfirmed({ signedoff: !this.signedOff });
        });
      }
    },
    openVerificationModal() {
      let title, yesBtnText, noBtnText;

      if (this.verified) {
        title = "Are you sure you want to rescind verification for this activity?";
        yesBtnText = 'Yes, change to "unverified" status';
        noBtnText = 'No, do not change to "unverified" status';
      } else {
        title = "Have you thoroughly verified this activity?";
        yesBtnText = 'Yes, change to "verified" status';
        noBtnText = 'No, do not change to "verified" status';
      }

      this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
        this.verificationConfirmed({ verified: !this.verified });
      });
    },
    openApprovalModal() {
      let title, desc, submitBtnText, cancelBtnText, yesBtnText, noBtnText;
      if (!this.approved) {
        title = "Approve Form";
        desc = `Herewith I confirm the completeness and correctness of the data by applying an electronic signature, using my account name and password.
      This electronic signature is the legally binding equivalent of my handwritten signature. I understand that this electronic signature is assigned
      only to my account name and password; no other person is authorized to use these.<br /><br />Please enter your username and password to approve.`;
        submitBtnText = "Yes, approve";
        cancelBtnText = "No, do not approve";

        this.$refs.userVerificationModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
          this.approvalConfirmed({ approved: !this.approved });
        });
      } else {
        title = "Are you sure you want to rescind approval for this activity?";
        yesBtnText = "Yes, unapprove";
        noBtnText = "No, do not unapprove";
        this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
          this.approvalConfirmed({ approved: !this.approved });
        });
      }
    },
    verificationConfirmed({ verified }) {
      const status = verified ? verificationStatus.VERIFIED : verificationStatus.NOT_VERIFIED;
      this.$emit("verificationConfirmed", status);
    },
    approvalConfirmed({ approved }) {
      const status = approved ? approvalStatus.APPROVED : approvalStatus.NOT_APPROVED;
      this.$emit("approvalConfirmed", status);
    },
    lockConfirmed({ locked }) {
      const status = locked ? lockStatus.LOCKED : lockStatus.UNLOCKED;
      this.$emit("lockConfirmed", status);
    },
    signoffConfirmed({ signedoff }) {
      const status = signedoff ? signoffStatus.SIGNEDOFF : signoffStatus.PENDING;
      this.$emit("signoffConfirmed", status);
    },
    reviewConfirmed({ review }) {
      const status = review ? reviewStatus.REVIEWED : reviewStatus.UNREVIEWED;
      this.$emit("reviewConfirmed", status);
    },
    sendMail(ref) {
      const dataObj = {
        studyId: this.studyId,
        participantId: this.participantId,
        docId: this.documentDetails.docId,
        data: {
          piName: this.user.firstName
        }
      };
      this.$api.sendMailFact(dataObj).then(
        response => {
          this.$toastr.success(response.body && response.body.message ? response.body.message : "Mail sent successfully");
          this.closeModal(ref, true, true);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while sending mail");
          this.closeModal(ref, true, true);
        }
      );
    },
    closeModal(ref, resetForConsent, resetForDocument, prop) {
      this.$refs[ref].hide();
      this.userCredentials = {
        username: "",
        password: ""
      };
      if (this.isDocConfigured) {
        if (prop && prop == "completed") {
          this.$emit("restoreFocus");
        }
        if (resetForDocument) {
          if (prop && prop == "signed") {
            this.signed = false;
            this.completed = false;
          } else if (prop && prop == "completed") {
            this.signed = true;
            this.completed = true;
          }
          this.setSignatureStatusAction(this.signatureStatuses.SIGNATURE_RESET);
          this.name = null;
          this.setSignatureAction(null);
          this.setBase64SignatureAction(null);
        }
      } else if (!this.isDocConfigured && resetForConsent) {
        if (prop && prop == "signed") {
          this.signed = false;
          this.completed = false;
        } else if (prop && prop == "completed") {
          this.signed = false;
          this.completed = false;
        }
        this.name = null;
        this.setSignatureAction(null);
        this.setBase64SignatureAction(null);
      }
      this.$refs.siteInitial.undoSignature();
      this.$refs.siteSignature.undoSignature();
    },
    setSiteSignatureData() {
      const { data } = this.$refs.siteSignature.saveSignature();
      const blob = this.dataURLToBlob(data);
      this.setSignatureAction(blob);
      if (data) {
        this.setBase64SignatureAction(data.split("base64,")[1]);
      }
    },
    confirmSign() {
      if (this.name) {
        this.signed = true;
        this.completed = true;
        this.showSignatureModal("loginModal");
      }
    },
    async loginUser() {
      if (this.signingIsInProcess) {
        return;
      }
      this.signingIsInProcess = true;
      if (!this.errors.any()) {
        const token = localStorageService.getItem("token");
        const tokenObj = jwtDecode(token);
        try {
          if ((this.awsCognitoAuthentication && this.awsCognitoAuthentication === true && this.user.cognitoUsername.toUpperCase().trim() === this.userCredentials.username.toUpperCase().trim()) || ((!this.awsCognitoAuthentication || this.awsCognitoAuthentication === false) && tokenObj.username.toUpperCase().trim() === this.userCredentials.username.toUpperCase().trim())) {
            this.userCredentials.electronicSignatureSignIn = "YES";
            await this.userLogin(this.userCredentials);
            if (this.documentDetails && this.documentDetails.consentId) {
              this.requestPISignature();
            } else if (this.witnessRoleOrders.length >= 1) {
              this.showSignatureModal("witnessConfirmationModal");
            } else {
              this.askForConfiguredDocumentSigning();
            }
          } else {
            // If Username is not same as the loggedin PI, comparison failed with vuex data
            this.$toastr.error("Access denied. You do not have access rights to sign this document.");
            this.signingIsInProcess = false;
          }
        } catch (error) {
          // If Username & Password incorrect, return from API
          this.$toastr.error("Access denied. You do not have access rights to sign this document.");
          this.signingIsInProcess = false;
        }
      } else if (!this.userCredentials.username && !this.userCredentials.password) {
        this.$toastr.error("Please enter your credentials.");
        this.signingIsInProcess = false;
      } else if (!this.userCredentials.username) {
        this.$toastr.error("Please provide your email, it is required");
        this.signingIsInProcess = false;
      } else if (!this.userCredentials.password) {
        this.$toastr.error("Please provide your password, it is required");
        this.signingIsInProcess = false;
      }
    },
    requestPISignature() {
      const signObj = new FormData();
      signObj.append("piSign", this.getSignatureData);
      signObj.append("name", this.name);
      const dataObj = {
        studyId: this.studyId,
        participantId: this.participantId,
        docId: this.documentDetails.docId,
        data: signObj
      };
      this.$api.requestPISignatureFact(dataObj).then(
        response => {
          this.$toastr.success(response.body && response.body.message ? response.body.message : "PI signature saved successfully");
          this.setSignatureStatusAction(this.signatureStatuses.SIGNATURE_COMPLETED);
          this.closeModal("loginModal", false, false);
          this.signingIsInProcess = false;
          this.$emit("pIDocSignatureStatus");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
          this.signingIsInProcess = false;
        }
      );
    },
    askForConfiguredDocumentSigning() {
      const data = { name: this.name, witnessData: this.witnessSignatures };
      this.setSignatureStatusAction(this.signatureStatuses.SIGNATURE_SUBMITTED);
      this.$emit("processSignatureData", data);
      this.$emit("pIDocSignatureStatus");
    },
    toggleMessageSection() {
      //Hide Agreement section if it is visible
      if (this.showDocuments) {
        this.showDocuments = false;
      } else if (this.toggleSendActivity) {
        this.toggleSendActivitySection(false, false);
      } else if (this.togglePreStudyStartActivity) {
        this.togglePreStudyStartSection(false, false);
      } else if (this.showMilestoneMessage) {
        this.showMilestoneMessage = false;
        this.$emit("toggleMilestoneAction", false);
      }

      this.showSendMessage = !this.showSendMessage;
      if (!this.composeMessageId) {
        this.composeMessageId = this.createCompseID();
        localStorageService.setItem(this.composeMessageId, {});
      }
      //Emit event to show/hide the site/participant task based on the send messages sec is open or not
      this.$emit("toggleSitePartTaskSec", !this.showSendMessage);
    },
    toggleMessageSecEvHan(value) {
      //This event is fired from compose-message component either by cancel composing/after sending msg
      this.showSendMessage = value;

      if (!value) {
        this.composeMessageId = null;
      }

      //Emit event to show/hide the site/participant task based on the send messages sec is open or not
      this.$emit("toggleSitePartTaskSec", !value);
    },
    createCompseID() {
      return (
        Array(16)
          .fill(0)
          .map(() => String.fromCharCode(Math.floor(Math.random() * 26) + 97))
          .join("") + Date.now().toString(24)
      );
    },
    collectBinaryData(ref) {
      this.signed = true;
      this.$refs[ref].hide();
      this.$emit("signatureCollected", { signCollected: true });
      this.setSignatureStatusAction(this.signatureStatuses.SIGNATURE_ACQUIRED);
    },
    showAuthenticationModal() {
      this.$refs["loginModal"].show();
      this.signed = true;
      this.completed = true;
    },
    verifyWitnesses() {
      this.showAuthenticationModal();
    },
    verifyWitnessTwo() {
      this.setWitnessSignature(1);
      this.setWitnessInitial(1);
      if (this.witnessRoleOrders.length > 1) {
        this.showSignatureModal("witnessTwoConfirmationModal");
      } else {
        this.setWitnessAndContinue();
      }
    },
    setWitnessAndContinue() {
      this.setWitnessSignature(2);
      this.setWitnessInitial(2);
      this.askForConfiguredDocumentSigning();
    },
    setWitnessInitial(roleOrder) {
      if (this.$refs[`witnessInitial${roleOrder}`]) {
        const { data } = this.$refs[`witnessInitial${roleOrder}`].saveSignature();
        if (data) {
          this.witnessSignatures[roleOrder].initial = data.split("base64,")[1];
          this.witnessSignatures[roleOrder].isInitialAdded = true;
        }
      }
    },

    setWitnessSignature(roleOrder) {
      if (this.$refs[`witnessSignature${roleOrder}`]) {
        const { data } = this.$refs[`witnessSignature${roleOrder}`].saveSignature();
        if (data) {
          this.witnessSignatures[roleOrder].signature = data.split("base64,")[1];
          this.witnessSignatures[roleOrder].isSigned = true;
        }
      }
    },
    clearAndShowAuth(roleOrder) {
      this.witnessSignatures[roleOrder] = {
        name: "",
        roleOrder,
        isSigned: false,
        isInitialAdded: false,
        signature: null,
        initial: null
      };
      if (this.$refs[`witnessSignature${roleOrder}`]) {
        this.$refs[`witnessSignature${roleOrder}`].undoSignature();
      }
      if (this.$refs[`witnessInitial${roleOrder}`]) {
        this.$refs[`witnessInitial${roleOrder}`].undoSignature();
      }
      if (roleOrder === 1) {
        this.witnessName = "";
      } else {
        this.witnessTwoName = "";
      }
      this.askForConfiguredDocumentSigning();
    },
    setName(e, roleOrder) {
      this.witnessSignatures[roleOrder].name = e.target.value;
    },
    initialize() {
      this.signed = false;
      this.completed = false;
      this.name = null;
    },
    toggleSendActivitySection(showParticipantSection, sendActivity) {
      this.toggleSendActivity = sendActivity;
      this.showSendMessage = false; // Remove messages section
      this.showDocuments = false;
      this.togglePreStudyStartActivity = false;
      this.showMilestoneMessage = false; // Remove documents section
      const data = {
        showParticipantSection: showParticipantSection,
        toggleSendActivity: this.toggleSendActivity,
        participantStudyStartTrigger: this.participantInfo.participantStudyStartTrigger.isConfirmed,
        studyVersionId: this.participantDetails.studyVersionId
      };
      this.$emit("toggleSendActivitySection", data);
    },
    async getDefaultSite() {
      this.sites = [];
      await this.$api.getSitesData(this.studyId).then(response => {
        if (response) {
          const sitesdata = response.body;
          sitesdata.map(el => {
            this.sites.push(el);
          });
        }
      });
      this.sites.filter(el => {
        if (el.isDefault === true) {
          localStorage.setItem("selectedSite", el.id);
        }
      });
    },
    getPreScreenedActivityCheck() {
      this.$api.getPreScreenedActivityCheck(this.studyId, this.$route.params.participantId).then(
        response => {
          this.isPreScreenedFlag = response.body;
          this.$forceUpdate();
        },
        error => {
          const err = error.body && error.body.message ? error.body.message : "Error while getting pre screened activity flag";
          this.$toastr.error(err);
        }
      );
    },
    togglePreStudyStartSection(showParticipantSection, PreStudyStartActivity) {
      this.togglePreStudyStartActivity = PreStudyStartActivity;
      this.showSendMessage = false; // Remove messages section
      this.showDocuments = false;
      this.toggleSendActivity = false;
      this.showMilestoneMessage = false; // Remove documents section
      this.$emit("toggleMilestoneAction", false);
      const data = {
        showParticipantSection: showParticipantSection,
        togglePreStudyStartActivity: this.togglePreStudyStartActivity,
        participantStudyStartTrigger: this.participantDetails.participantStudyStartTrigger.isConfirmed
      };
      this.$emit("togglePreStudyStartSection", data);
    },
    dataURLToBlob(dataURL) {
      let byteString = null;
      if (dataURL.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(dataURL.split(",")[1]);
      } else {
        byteString = unescape(dataURL.split(",")[1]);
      }

      // separate out the mime component
      const mimeString = dataURL
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      // write the bytes of the string to a typed array
      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    // ---------------------------------
    // |   Resend Document Code Start  |
    // ---------------------------------
    openInvalidateModal() {
      this.$refs.InvalidateModal.show();
    },
    invalidateDocument() {
      this.$refs.resendModal.show();
    },
    resendDocument(status) {
      const obj = {
        studyId: this.studyId,
        participantId: this.participantId,
        docId: this.documentDetails.docId,
        status: status
      };
      this.$api.participantResendDocument(obj, "").then(
        () => {
          if (status) {
            this.$router.push({
              name: "participant-profile",
              params: { participantId: this.participantId }
            });
          } else {
            this.isButtonCanceled = true;
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "");
        }
      );
    },
    checkLegacyValue() {
      this.$api.getLegacyData(this.studyId).then(response => {
        if (response) {
          this.legacyVal = response.body;
        }
      });
    },
    getParticipantDetails() {
      this.$api.getParticipantDataFactV2(this.studyId, this.participantId).then(
        response => {
          this.participantInfo = response.body;
          this.toggleSendActivitySection(true, !this.toggleSendActivity);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
    }
  },
  mounted() {
    if (this.user.userRole === "Interviewer") {
      this.getDefaultSite();
    }
    this.getStudyDetails();
    this.$root.$on("videoCallEnded", () => {
      this.isCallBtnDisabled = false;
    });
    this.$root.$on("videoCallCancelled", () => {
      this.isCallBtnDisabled = false;
    });
    this.getActivityList();
    this.getPreScreenedActivityCheck();
    this.checkLegacyValue();
  },
  updated() {
    const flag = localStorage.getItem("isPreScreenedFlag");
    if (flag && !this.isPreScreenedFlag) {
      this.isPreScreenedFlag = true;
      this.$forceUpdate();
      localStorage.removeItem("isPreScreenedFlag");
    } else if (this.isPreScreenedFlag) {
      this.isPreScreenedFlag = true;
    } else {
      this.isPreScreenedFlag = false;
    }
  }
};
</script>
<style scoped lang="scss" src="@/assets/participant-information.scss"></style>
<style scoped lang="scss">
.witness-modal-body {
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 2rem 3rem !important;
}
.yes-custom-btn {
  width: 100%;
  background-color: #4c8ce4;
  margin-top: 0.6rem;
}
.no-custom-btn {
  width: 100%;
  background-color: #a5b2c1;
  margin-top: 0.6rem;
}
.participant-detail-section {
  width: 100%;
  .language-selection {
    position: absolute;
    top: 10px;
    left: 0px;
  }

  .language-dropdown {
    background: #5290e7 url(/static/img/arrow-down-blue.png) no-repeat;
    border: 0;
    width: auto;
    background-color: transparent !important;
    background-position-x: 96% !important;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .custom-select {
    &:focus {
      box-shadow: none;
    }
  }
}
.h3 {
  font-size: 1.25rem;
  color: #666669;
}

/deep/ .signature-modal {
  .witness-modal-body {
    padding: 2rem;
  }
  .modal-body-custom {
    padding: 2rem;

    label {
      color: #4a4a4a;
    }

    .signature {
      .btn.btn-link {
        font-weight: bold;
      }
    }
  }
}
.action-buttons {
  button {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    border: 0px;
    border-radius: 2px;
    height: 41px;

    &:first-child {
      background-color: #4c8ce4;
    }

    &:last-child {
      background-color: #a5b2c1;
    }
  }
}

.signature-canvas {
  margin: 8px 0 4px;
  border-radius: 4px;
  border: solid 1px #c9c9c9;
}

.invalidate-btn {
  cursor: pointer;
}

.invalidate-btn-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

a {
  &.clear {
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1e8fe1;
    cursor: pointer;
  }

  &:hover {
    color: #1e8fe1 !important;
  }
}
.documentname-Wrap {
  word-wrap: break-word;
}
</style>
